import { Link } from "react-router-dom";
import css from "./Offerings.module.css";

const Resource = ({ resource }) => {
  return (
    <Link to={resource.link} className={css.resource}>
      <strong className={css.resource_name}>{resource.name}</strong>
      <div className={css.resource_arrow_container}>
        <img
          className={css.arrow}
          src={require("../../images/arrow_thick.png")}
          alt="arrow"
        />
      </div>
    </Link>
  );
};

export default Resource;
